import { frappe } from "./frappeClient";

// Frappe login endpoint: POST /api/method/login :contentReference[oaicite:1]{index=1}
export async function loginToFrappe({ username, password }) {
    // Frappe commonly accepts form-data style
    const form = new URLSearchParams();
    form.append("usr", username);
    form.append("pwd", password);

    const res = await frappe.post("/api/method/login", form, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
    });

    // Typical response has message/full_name/home_page etc (varies by version)
    return res.data;
}

// Get current logged in user :contentReference[oaicite:2]{index=2}
export async function getLoggedUser() {
    const res = await frappe.get("/api/method/frappe.auth.get_logged_user");
    return res.data?.message;
}

export async function logoutFromFrappe() {
    await frappe.get("/api/method/logout"); // :contentReference[oaicite:3]{index=3}
}
